import { FETCH_PETASKS_SUCCESS, FETCH_QUOTEID_PE_SUCCESS, FETCH_PE_MAPPING_SUCCESS, FETCH_NAME_MAPPING_SUCCESS, FETCH_CITY_MAPPING_SUCCESS, FETCH_STATE_SUBSIDY_MAPPING, FETCH_CITY_DISCOM_MAPPING, UPDATE_AUTO_ASSIGN_STATUS, FETCH_LOGGEDIN_USERNAME, FETCH_TASK_COMMENTS, FETCH_PM_MAPPING_SUCCESS } from './actiontypes';
import axios from 'axios';
import moment from 'moment';
import { base, db } from '../connection';
import swal from 'sweetalert';

// const taskFields = ['date', 'quoteId', 'state', 'type', 'startTime', 'employee', 'comment', 'priority'];
const taskFields = ['date', 'state', 'type', 'priority', 'city'];
const baseUrl = `https://operations.zunroof.com`;
// const baseUrl = `http://localhost:3002`;

export function fetchPeTask(filters) {
    return (dispatch) => {
        getPeTasks(filters)
            .then(data => {
                dispatch({ type: FETCH_PETASKS_SUCCESS, payload: data })
            })
            .catch(e => {
                console.log(e);
                return e;
            })
    }
}

export function fetchPeTaskByQuoteId(quoteId) {
    return async (dispatch) => {
        try {
            console.log("fetchPeTaskByQuoteId", quoteId);
            let formdata = new URLSearchParams();
            formdata.append('quoteId', quoteId);
            let responseData = await axios.post(`${baseUrl}/api/petasksv2/fetch`, formdata, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            });
            responseData = responseData.data || {};
            let peData = [];
            if (responseData && responseData.tasks) {
                let apiData = responseData.tasks || [];
                apiData.forEach(taskObj => {
                    taskObj.statusVal = taskObj.status == "1" ? "Completed" : "Pending";
                    peData.push(taskObj);
                })
            }
            dispatch({ type: FETCH_PETASKS_SUCCESS, payload: peData });
        }
        catch (error) {
            console.log("Error in fetchPeTaskByQuoteId", error);
        }
    }
}

async function getPeTasks(filters) {
    try {
        let { startDate, endDate, team, status } = filters;
        let formdata = new URLSearchParams();
        // if (!startDate || !endDate) {
        //     startDate = moment().format('YYYYMMDD');
        //     endDate = moment().add(7, 'days').format('YYYYMMDD');
        // }
        // else {
        //     startDate = moment(startDate, "YYYY-MM-DD").format("YYYYMMDD");
        //     endDate = moment(endDate, "YYYY-MM-DD").format("YYYYMMDD");
        // }
        if(startDate) {
            startDate = moment(startDate, "YYYY-MM-DD").format("YYYYMMDD");
            formdata.append('startDate', startDate);
        }
        if(endDate) {
            endDate = moment(endDate, "YYYY-MM-DD").format("YYYYMMDD");
            formdata.append('endDate', endDate);
        }
        if(team) formdata.append('team', team);
        if(status) formdata.append('status', status);
        let responseData = await axios.post(`${baseUrl}/api/petasksv2/fetch`, formdata, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        });
        responseData = responseData.data || {};
        let peData = [];
        if (responseData && responseData.tasks) {
            let apiData = responseData.tasks || [];
            apiData.forEach(taskObj => {
                taskObj.statusVal = taskObj.status == "1" ? "Completed" : "Pending";
                peData.push(taskObj);
            })
        }
        return peData;
    }
    catch (e) {
        return [];
    }
}

export function fetchQuoteId() {
    return (dispatch) => {
        getQuoteId()
            .then(data => {
                dispatch({ type: FETCH_QUOTEID_PE_SUCCESS, payload: data })
            })
            .catch(e => {
                console.log(e);
                return e;
            })
    }
}

async function getQuoteId() {
    try {
        let deliverySites = (await db.ref(`delivery/webPortal/deliverySiteMapping`).once('value')).val();
        let quoteList = await Promise.all(Object.keys(deliverySites ? deliverySites : {}).map(async siteId => {
            let quoteId = deliverySites[siteId];
            let userId = (await db.ref(`mapstore/quoteidtocustomerid/${quoteId}`).once('value')).val();
            let quoteData = {
                quoteId: quoteId,
                name: ''
            }
            if (userId) {
                let userData = (await db.ref(`/users/${userId}/mUser_Contact`).once('value')).val();
                let name = "";
                if (userData) {
                    name = `${userData.mContact_FirstName || ""} ${userData.mContact_FirstName || ""}`
                }
                let webPortalObj = (await db.ref(`delivery/webPortal/sites/${siteId}`).once('value')).val() || {};
                let state = webPortalObj.state_D;
                let gridTied = webPortalObj.systemType_D;
                if (!state || !gridTied) {
                    let siteObj = (await db.ref(`sites/${siteId}`).once('value')).val() || {};
                    state = state ? state : siteObj.mSite_State;
                    gridTied = gridTied ? gridTied : siteObj.mSite_SystemType;
                }
                quoteData = {
                    quoteId,
                    name,
                    state,
                    gridTied
                }
            }
            return quoteData;
        }));
        return quoteList;
    }
    catch (e) {
        return [];
    }
}

export function fetchPeMapping() {
    return (dispatch) => {
        fetchMapping()
            .then(data => {
                dispatch({ type: FETCH_PE_MAPPING_SUCCESS, payload: data.peMapping })
                dispatch({ type: FETCH_NAME_MAPPING_SUCCESS, payload: data.employeeList })
                dispatch({ type: FETCH_CITY_MAPPING_SUCCESS, payload: data.stateCityMap })
                dispatch({ type: FETCH_STATE_SUBSIDY_MAPPING, payload: data.stateSubsidyMapping })
                dispatch({ type: FETCH_CITY_DISCOM_MAPPING, payload: data.cityDiscomMapping })
                dispatch({ type: FETCH_PM_MAPPING_SUCCESS, payload: data.pmMapping })
            })
            .catch(e => {
                console.log(e);
                return e;
            })
    }
}

async function fetchMapping() {
    try {
        // let mapping = (await db.ref(`/website/peMapping`).once('value')).val();
        let [mapping, stateCityList, centersList, usersList, roleMapping] = await Promise.all([
            db.ref(`/delivery/teamtoEmployeeMapping`).once('value'),
            db.ref(`uploads/systemdesign/state_city_list_0`).once('value'),
            db.ref(`website/peTasksCenters`).once('value'),
            db.ref(`employeelist`).once('value'),
            db.ref(`/webDelivery/userrolemapping`).once('value')
        ]);
        mapping = mapping.val() || {};
        usersList = usersList.val() || {};
        roleMapping = roleMapping.val() || {};
        let peMapping = {}, pmMapping = [];
        let allUsers = {};
        let peStateMap = {};
        Object.keys(mapping).forEach(teamId => {
            let teamName = mapping[teamId].teamName || "";
            if (teamName == 'Others') return;
            Object.keys(mapping[teamId].members).forEach(pePhone => {
                if (!peStateMap[pePhone]) peStateMap[pePhone] = [];
                peStateMap[pePhone].push(teamName);
            })
        })
        console.log(peStateMap);
        Object.keys(usersList).forEach(userPhone => {
            let accessObj = usersList[userPhone];
            if (accessObj.role <= 100 || roleMapping[userPhone] < 1600) return;
            allUsers[userPhone] = 1;
            if (peStateMap[userPhone] && peStateMap[userPhone].length) {
                peStateMap[userPhone].forEach(state => {
                    if (!peMapping[state]) peMapping[state] = [];
                    peMapping[state].push(userPhone);
                })
            }
            else {
                pmMapping.push(userPhone);
            }
        })
        console.log(peMapping);
        console.log(pmMapping);
        stateCityList = stateCityList.val() || {};
        centersList = centersList.val() || {};
        let stateCityMap = {};
        let employeeList = {};
        let stateSubsidyMapping = {}, cityDiscomMapping = {};
        if (allUsers && Object.keys(allUsers).length) {
            await Promise.all(Object.keys(allUsers).map(async employeeId => {
                let userObj = (await db.ref(`users/${employeeId}/mUser_Contact`).once('value')).val();
                let name = userObj ? `${userObj.mContact_FirstName || ""} ${userObj.mContact_LastName || ""}` : "";
                employeeList[employeeId] = name.trim() || employeeId;
            }))
        }
        Object.keys(peMapping).map(state => {
            stateCityMap[state] = stateCityList[state] || [];
        })
        Object.values(centersList).map(row => {
            if (row.centerType == "Subsidy") {
                if (!stateSubsidyMapping[row.state]) {
                    stateSubsidyMapping[row.state] = [];
                }
                stateSubsidyMapping[row.state].push({ label: row.centerName, value: row.key });
            }
            else if (row.centerType == "Discom") {
                if (!cityDiscomMapping[row.city]) {
                    cityDiscomMapping[row.city] = [];
                }
                cityDiscomMapping[row.city].push({ label: row.centerName, value: row.key });
            }
        })
        return {
            peMapping: peMapping,
            employeeList,
            stateCityMap,
            stateSubsidyMapping,
            cityDiscomMapping,
            pmMapping
        }
    }
    catch (e) {
        console.log("Error in fetchPeMapping", e);
        return {
            peMapping: {},
            employeeList: {},
            stateCityMap: {},
            stateSubsidyMapping: {},
            cityDiscomMapping: {},
            pmMapping: []
        }
    }
}


export function createNewTask(taskObj, peTasks, userId) {
    return (dispatch) => {
        createTask(taskObj, peTasks, userId).then(tasks => {
            dispatch({ type: FETCH_PETASKS_SUCCESS, payload: tasks })
        })
    }
}

async function createTask(taskObj, peTasks, userId) {
    try {
        if (checkFields(taskObj)) {
            if (!taskObj.size_del && taskObj.type.includes("Layout")) {
                swal('Please fill Size_del variable in the Quote Id View.');
                return peTasks;
            }
            let { date, comment = "", pmComment = "", employee = "", type, quoteId = "", state, priority, city, centerKey = "", team = "" } = taskObj;
            let taskDate = moment(date, "YYYY-MM-DD").format('YYYYMMDD');
            // let taskStartTime = startTime ? moment(`${date} ${startTime}:00`, 'YYYY-MM-DD HH:mm').valueOf() : "";
            let formdata = new URLSearchParams();
            formdata.append("date", taskDate);
            // formdata.append("startTime", taskStartTime);
            formdata.append("state", state);
            formdata.append("quoteId", quoteId);
            formdata.append("comment", comment);
            formdata.append("pmComment", pmComment);
            formdata.append("type", type);
            formdata.append("employeeId", employee);
            formdata.append("priority", priority);
            formdata.append("city", city);
            formdata.append("centerKey", centerKey);
            formdata.append("team", team);
            formdata.append("userId", userId);
            let data = await axios.post(`${baseUrl}/api/petasksv2/create`, formdata, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            });
            if (data && data.data) {
                let addTaskStatus = data.data;
                if (addTaskStatus.Error) {
                    swal(addTaskStatus.Error);
                    return peTasks;
                }
                else {
                    swal('Task Added');
                    let addedTask = {
                        date: taskDate,
                        state,
                        comment,
                        pmComment,
                        type,
                        employeeId: employee,
                        taskId: addTaskStatus.Data,
                        quoteId,
                        priority: priority,
                        status: "0",
                        statusVal: "Pending",
                        city: city,
                        team: team
                    }
                    return [addedTask, ...peTasks];
                }
            }
            return peTasks;
        }
        else {
            swal('Please Check all the fields');
            return peTasks;
        }
    }
    catch (e) {
        return peTasks;
    }
}

function checkFields(taskObj) {
    try {
        if (taskObj.type != "Subsidy" && !taskObj.quoteId) {
            return false;
        }
        let status = true;
        taskFields.map(field => {
            if (!taskObj[field]) {
                status = false;
            }
        })
        return status;
    }
    catch (e) {
        return false;
    }
}


export function updateTask(task, peTasks, userId) {
    return (dispatch) => {
        updatePeTask(task, peTasks, userId).then(data => {
            dispatch({ type: FETCH_PETASKS_SUCCESS, payload: data })
        })
    }
}

async function updatePeTask(task, peTasks, userId) {
    try {
        if (checkFields(task) && task.id) {
            let { date, comment = "", pmComment = "", employee = "", type, quoteId = "", state, priority, status, statusVal, city, centerKey = "", team = "" } = task;
            let taskDate = moment(date, "YYYY-MM-DD").format('YYYYMMDD');
            // let taskStartTime = startTime ? moment(`${date} ${startTime}:00`, 'YYYY-MM-DD HH:mm').valueOf() : "";
            let formdata = new URLSearchParams();
            formdata.append("taskId", task.id);
            formdata.append("date", taskDate);
            // formdata.append("startTime", taskStartTime);
            formdata.append("state", state);
            formdata.append("quoteId", quoteId);
            formdata.append("comment", comment);
            formdata.append("pmComment", pmComment);
            formdata.append("type", type);
            formdata.append("employeeId", employee);
            formdata.append("priority", priority);
            formdata.append("status", status || "0");
            formdata.append("city", city);
            formdata.append("centerKey", centerKey);
            formdata.append("team", team);
            formdata.append("userId", userId);
            let data = await axios.post(`${baseUrl}/api/petasksv2/update`, formdata, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            });
            if (data && data.data) {
                let addTaskStatus = data.data;
                if (addTaskStatus.Error) {
                    swal(addTaskStatus.Error);
                    return peTasks;
                }
                else {
                    swal('Task Updated');
                    let tasks = [...peTasks];
                    let index = tasks.findIndex(val => val.taskId == task.id);
                    tasks[index] = {
                        date: taskDate,
                        state,
                        comment,
                        pmComment,
                        type,
                        employeeId: employee,
                        taskId: task.id,
                        quoteId,
                        priority,
                        status,
                        statusVal,
                        city,
                        team: team
                    };
                    return tasks;
                }
            }
            return peTasks;
        }
        else {
            swal('Please Check all the fields');
            return peTasks;
        }
    }
    catch (e) {
        return peTasks;
    }
}

export function deleteTask(taskId, peData, userId) {
    return (dispatch) => {
        let taskData = (peData || []).find(task => taskId == task.taskId);
        let date = taskData.date;
        let formdata = new URLSearchParams();
        formdata.append("taskId", taskId);
        formdata.append("date", date);
        formdata.append("userId", userId);
        axios.post(`${baseUrl}/api/petasksv2/delete`, formdata, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then(data => {
            if (data && data.data) {
                let res = data.data;
                if (res.Error) {
                    swal(res.Error);
                }
                else {
                    swal("Task Deleted");
                    let finalData = (peData || []).filter(task => task.taskId != taskId);
                    dispatch({ type: FETCH_PETASKS_SUCCESS, payload: finalData });
                }
            }
        })
    }
}

export function markTaskComplete(taskId, peData, userId) {
    return (dispatch) => {
        let taskData = (peData || []).find(task => taskId == task.taskId);
        let date = taskData.date;
        let formdata = new URLSearchParams();
        formdata.append("taskId", taskId);
        formdata.append("date", date);
        formdata.append("userId", userId);
        axios.post(`${baseUrl}/api/petasksv2/markComplete`, formdata, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then(data => {
            if (data && data.data) {
                let res = data.data;
                if (res.Error) {
                    swal(res.Error);
                }
                else {
                    swal("Task marked completed");
                    let tasks = [...peData];
                    let index = tasks.findIndex(val => val.taskId == taskId);
                    tasks[index].status = "1";
                    tasks[index].statusVal = "Completed";
                    dispatch({ type: FETCH_PETASKS_SUCCESS, payload: tasks });
                }
            }
        })
    }
}

export function searchSites(searchString = '', type) {
    return async (dispatch) => {
        try {
            let response = await axios.post(`${baseUrl}/api/searchsites`, { searchString, type, key: "4KdOQUVM8eJyEmN" });
            let data = response.data || [];
            dispatch({ type: FETCH_QUOTEID_PE_SUCCESS, payload: data || [] })
        }
        catch (e) {
            console.log(e);
            dispatch({ type: FETCH_QUOTEID_PE_SUCCESS, payload: [] })
        }
    }
}

export function resetAutoAssign() {
    return (dispatch) => {
        dispatch({ type: UPDATE_AUTO_ASSIGN_STATUS, payload: { value: 0 } });
        return;
    }
}


export function autoAssignTasks(data) {
    return async (dispatch) => {
        if (!data.city || !data.date) {
            swal('Please Check all the fields');
            return;
        }
        dispatch({ type: UPDATE_AUTO_ASSIGN_STATUS, payload: { value: 1, text: "Assigning tasks. Please wait..." } });
        data.date = moment(data.date, "YYYY-MM-DD").format("YYYYMMDD");
        let response = await axios.post(`${baseUrl}/api/assignpetasks`, data);
        response = response.data || {};
        if (response.error) {
            dispatch({ type: UPDATE_AUTO_ASSIGN_STATUS, payload: { value: 3, text: response.error } });
            return;
        }
        dispatch({ type: UPDATE_AUTO_ASSIGN_STATUS, payload: { value: 3, text: response.data } });
        return;
    }
}

export function fetchLoggedInUserName(userId) {
    return async (dispatch) => {
        try {
            let userObj = (await db.ref(`/users/${userId}/mUser_Contact`).once('value')).val() || {};
            let { mContact_FirstName = '', mContact_LastName = '' } = userObj;
            let userName = `${mContact_FirstName} ${mContact_LastName}`.trim();
            dispatch({ type: FETCH_LOGGEDIN_USERNAME, payload: userName });
        }
        catch (error) {
            console.log("Error in fetchLoggedInUserName", error);
            return;
        }
    }
}

export function addNewComment(commentObj) {
    return async (dispatch) => {
        try {
            let responseData = await axios.post(`${baseUrl}/api/petasksv2/addnewcomment`, commentObj);
            responseData = responseData.data;
            if (!responseData.success) {
                swal(responseData.error || "Some error occured");
                return;
            }
        }
        catch (error) {
            console.log("Error in fetchLoggedInUserName", error);
            return;
        }
    }
}

export function fetchTaskComments(taskId) {
    return async (dispatch) => {
        try {
            let responseData = await axios.post(`${baseUrl}/api/petasksv2/fetchcomments`, { taskId: taskId });
            responseData = responseData.data;
            if (!responseData.success) {
                swal(responseData.error || "Some error occured");
                return;
            }
            let comments = responseData.comments || [];
            dispatch({ type: FETCH_TASK_COMMENTS, payload: comments });
        }
        catch (error) {
            console.log("Error in fetchLoggedInUserName", error);
            return;
        }
    }
}